<template>
  <div :class="{ [`aml-Logo-${placement}`]: true }" class="aml-Logo">
    <AppLink :to="`${ROUTE_PATHS.WORKSPACES}${workspaceId}`">
      <template #default="{ href, onClick }">
        <AppLinkResolver
          :class="{
            'aml-Logo_Link-p0': isMenuCollapsed
          }"
          :href="href"
          class="aml-Logo_Link"
          @click.prevent="onClick"
        >
          <AppLogo v-bind="logoAttrs" />
        </AppLinkResolver>
      </template>
    </AppLink>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import { ROUTE_PATHS } from '@/routes/route-helpers'
import { APP_MENU_LOGO_PLACEMENTS, useAppMenu } from '@/utils/app-menu'
import { includesValue } from '@/utils/prop-validators'

import AppLogo from '@/components/AppLogo'
import AppLink from '@/components/ui/AppLink/AppLink'
import AppLinkResolver from '@/components/ui/AppLink/AppLinkResolver'

defineOptions({
  name: 'AppMenuLogo'
})

defineProps({
  placement: {
    type: String,
    default: APP_MENU_LOGO_PLACEMENTS.MAIN_MENU,
    validator: v => includesValue(v, APP_MENU_LOGO_PLACEMENTS)
  }
})

const store = useStore()

const workspaceId = store.state.workspaces.workspaceId

const { isMenuCollapsed, isMenuExpanded } = useAppMenu()

const logoAttrs = computed(() => {
  if (isMenuExpanded.value) {
    return {
      height: 24,
      width: 127
    }
  }

  return {
    height: 40,
    width: 40,
    type: 'short'
  }
})
</script>

<style lang="scss" scoped>
.aml-Logo {
  display: flex;
  align-items: center;

  &-main-menu {
    margin-bottom: 16px;
  }

  &-additional-menu {
    margin-bottom: 16px;
  }
}

.aml-Logo_Link {
  display: flex;
  &:not(&-p0) {
    padding: 8px;
  }
}
</style>
